module.exports = __webpack_public_path__ + "img/undraw_pitching_36ol.83f2f555.svg";